import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import LoggedInLayout from "./components/LoggedInLayout";
import IndexPage from "./pages/IndexPage";
import Home from './pages/Home';
import OrganizationsPage from "./pages/OrganizationsPage";
import CreateOrganizationPage from "./pages/CreateOrganizationPage";
import InvitesPage from "./pages/InvitesPage";
import CreateInvitePage from "./pages/CreateInvitePage";
import MembersPage from "./pages/MembersPage";
import MemberDetailsPage from "./pages/MemberDetailsPage";
import MemberEnrollPage from "./pages/MemberEnrollPage";
import MemberAccomplishmentPage from "./pages/MemberAccomplishmentPage";
import MemberAttendancePage from "./pages/MemberAttendancePage";
import MemberSkillsPage from "./pages/MemberSkillsPage";
import GroupsPage from "./pages/GroupsPage";
import GroupDetailsPage from "./pages/GroupDetailsPage";
import CreateGroupPage from "./pages/CreateGroupPage";
import EditGroupPage from "./pages/EditGroupPage";
import GroupAttendancePage from "./pages/GroupAttendancePage";
import GroupSnippetsPage from "./pages/GroupSnippetsPage";
import CurriculumsPage from "./pages/CurriculumsPage";
import CreateCurriculumPage from "./pages/CreateCurriculumPage";
import ImportCurriculumPage from "./pages/ImportCurriculumPage";
import CurriculumDetailsPage from "./pages/CurriculumDetailsPage";
import LevelDetailsPage from "./pages/LevelDetailsPage";
import AccomplishmentsPage from "./pages/AccomplishmentsPage";
import AccomplishmentDetailsPage from "./pages/AccomplishmentDetailsPage";
import NotesPage from "./pages/NotesPage";
import SnippetsPage from "./pages/SnippetsPage";
import ManageSnippetsPage from "./pages/ManageSnippetsPage";
import GenerateSnippetsPage from "./pages/GenerateSnippetsPage";
import CreateSnippetPage from "./pages/CreateSnippetPage";
import SnippetDetailPage from "./pages/SnippetDetailPage";
import SkillsPage from "./pages/SkillsPage";
import SkillDetailsPage from "./pages/SkillDetailsPage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import JoinPage from "./pages/JoinPage";
import SearchPage from "./pages/SearchPage";
import SecurityPage from "./pages/SecurityPage";
import ReportsPage from "./pages/ReportsPage";
import GroupDetailsReport from './reports/GroupDetailsReport';
import GroupAttendanceReport from './reports/GroupAttendanceReport';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/"
          element={
            <IndexPage />
          }
        />
        <Route
          path="/login"
          element={
            <LoginPage />
          }
        />
        <Route
          path="/register"
          element={
            <RegisterPage />
          }
        />
        {/* Protected Routes */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <Home {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <ProfilePage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <OrganizationsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <CreateOrganizationPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <MembersPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <MemberDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/notes"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <NotesPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/snippets"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SnippetsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/snippets"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <ManageSnippetsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/snippets/generate"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <GenerateSnippetsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/snippets/:snippet_id"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SnippetDetailPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/snippets/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <CreateSnippetPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/enroll"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <MemberEnrollPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/accomplishment"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <MemberAccomplishmentPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/attendance"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <MemberAttendancePage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/members/:member_id/skills"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <MemberSkillsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/invites"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <InvitesPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/invites/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <CreateInvitePage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <GroupsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <CreateGroupPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups/:group_id"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <GroupDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups/:group_id/edit"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <EditGroupPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups/:group_id/attendance"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <GroupAttendancePage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/groups/:group_id/snippets"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <GroupSnippetsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/curriculums"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <CurriculumsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/curriculums/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <CreateCurriculumPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/curriculums/import"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <ImportCurriculumPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/curriculums/:curriculum_id"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <CurriculumDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/levels/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <LevelDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/levels/:level_id"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <LevelDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/accomplishments"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <AccomplishmentsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/accomplishments/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <AccomplishmentDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/accomplishments/:accomplishment_id"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <AccomplishmentDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/skills"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SkillsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/skills/create"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SkillDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/skills/:skill_id"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SkillDetailsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/join"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <JoinPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/search"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SearchPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SettingsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/security"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <SecurityPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <ReportsPage {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/group-details"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <GroupDetailsReport {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports/group-attendance"
          element={
            <ProtectedRoute>
              {(props) => (
                <LoggedInLayout {...props}>
                  <GroupAttendanceReport {...props} />
                </LoggedInLayout>
              )}
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App; 